import styled from "styled-components";
import {
  layout,
  space,
  typography,
  flexbox,
  color,
  position,
  border
} from "styled-system";

export const Container = styled.div`
  ${layout};
  ${space};
  ${flexbox};
  ${typography};
  ${color};
  ${position};
  ${border};
`;
